import type { ParcelAPNParams, ParcelPointParams } from '~/postgres.server'
import type { loader as ParcelAPNLoader } from '~/routes/api.parcels.apn/route'
import type { loader as ParcelPointLoader } from '~/routes/api.parcels.point/route'

type HasToString = {
  toString(): string
}

function paramsToQuery<T extends Record<string, HasToString>>(
  params: T
): string {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    query.set(key, value.toString())
  })

  return `?${query.toString()}`
}

export async function getParcelsByAPN(params: ParcelAPNParams) {
  const response = await fetch(`/api/parcels/apn${paramsToQuery(params)}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok || response.bodyUsed) {
    throw new Error(
      `Error fetching parcel: ${response.status} ${response.statusText}`
    )
  }

  const data = (await response.json()) as Awaited<
    ReturnType<typeof ParcelAPNLoader>
  >

  if ('parcels' in data) {
    return data
  } else {
    throw new Error(`Error fetching parcel: invalid response data`)
  }
}

export async function getParcelsByPoint(params: ParcelPointParams) {
  const response = await fetch(`/api/parcels/point${paramsToQuery(params)}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok || response.bodyUsed) {
    throw new Error(
      `Error fetching parcel: ${response.status} ${response.statusText}`
    )
  }

  const data = (await response.json()) as Awaited<
    ReturnType<typeof ParcelPointLoader>
  >

  if ('parcels' in data) {
    return data
  } else {
    throw new Error(`Error fetching parcel: invalid response data`)
  }
}
